import { useContext, useState } from 'react';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material';

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";


export const BulkModal = (props) => {
  const { items, onClose } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [ value, setValue ] = useState(items.length === 1 && items[0]?.priceInfo?.quantity || "")
  const { account, selectedStore, updateItem } = useContext(AuthContext);


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    onClose();
  }

  const handleSave = () => {
    Tracking.track('Portal - Bulk edit Quantity', { items: items.length })
    let bulk_update = []

    items.forEach((item) => {
      let priceInfoDefaults = {
        quantity: 0,
        price: 0,
        retailPrice: 0,
        markup: 0,
        currency: account.acctStores[selectedStore].currency,
        retailPriceCurrency: account.acctStores[selectedStore].currency,
      }

      let priceInfo = {
        ...priceInfoDefaults,
        ...item.priceInfo
      }

      priceInfo.quantity = parseInt(value)

      bulk_update.push(new Promise((resolve, rejejct) => {
        updateItem(
          item,
          {
            priceInfo
          },
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }

  
  return (
    <>
      <MenuItem onClick={handleOpen}>
        <div>Quantity</div>
      </MenuItem>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Set Quantity</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Change quantity of all of your selected items
          </DialogContentText>
          {/*  */}
          <TextField
            variant='standard'
            label=""
            value={value}
            onChange={(e) => { setValue(e.target.value) }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}